import { Link } from "react-router-dom";
import "./css/header.css";
import { useEffect, useState } from "react";

const Header = () => {
  const [isMobileMenuOpened, setIsMobileMenuOpened] = useState(false);

  // useEffect(() => {
  //   console.log("isMobileMenuOpened", isMobileMenuOpened)
  // }, [isMobileMenuOpened])
  const bottom_left_links = [
    {
      title: "Home",
      to: "/",
    },
    // {
    //   title: "Register",
    //   to: "https://eschools-zw.app.brainstake.tech/parent_self_registration",
    // },
    {
      title: "Send Enquiry",
      to: "#",
    },
    {
      title: "Gallery",
      to: "#",
    },
    {
      title: "FAQ",
      to: "#",
    },
    {
      title: "Contact Us",
      to: "/#contact_us",
    },
  ];
  const bottom_right_links = [
    {
      title: "+263711951133",
      to: "tel:+263711951133",
      css_class: "header_phone",
    },
    {
      title: "info@brainstake.tech",
      to: "mailto:info@brainstake.tech",
      css_class: "header_email",
    },
  ];

  return (
    <div className="menu">
      <div className="top">
        <div className="logo_and_hamburger">
          <button
            className="hamburger_menu"
            onClick={(e) => {
              e.target.parentElement.parentElement.parentElement
                .querySelector(".bottom")
                .classList.toggle("hide_menu_on_mobile");
              e.target.classList.toggle("menu_opened");
            }}
          ></button>
          <Link className="left" to="/"></Link>
        </div>
        <div className="ctas">
          <Link
            to="https://admin.eschools.tech"
            className="cta login"
            target="_blank"
            style={{ width: "150px" }}
          >
            Admin Login
          </Link>
          <Link
            to="https://app.eschools.tech/login"
            className="cta login"
            target="_blank"
          >
            Login
          </Link>
          <button
            className="cta book_demo"
            onClick={() => {
              document
                .querySelector(".book_demo_container")
                ?.classList?.toggle("displayed_none");
            }}
          >
            Get A Free Demo
          </button>
        </div>
      </div>
      <div className="bottom hide_menu_on_mobile">
        <div className="left">
          {bottom_left_links?.map(({ title, to }, index) =>
            title.toLowerCase() === "contact us" ? (
              <a key={index} className="to_contact_us" href={to}>
                {title}
              </a>
            ) : title.toLowerCase() === "register" ? (
              <Link key={index} to={to} target="_blank">
                {title}
              </Link>
            ) : (
              <Link key={index} to={to}>
                {title}
              </Link>
            )
          )}
          {bottom_right_links?.map(({ title, to, css_class }, index) => (
            <Link key={index} to={to} className={`${css_class} show_on_mobile`}>
              {title}
            </Link>
          ))}
        </div>
        <div className="right hide_on_mobile">
          {bottom_right_links?.map(({ title, to, css_class }, index) => (
            <Link key={index} to={to} className={`${css_class}`}>
              {title}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Header;
